// extracted by mini-css-extract-plugin
module.exports = {"lia-dropdown-menu-index":"TermsOfServiceActionMenu_lia-dropdown-menu-index__1vd3z"};